import React from "react";
import { MainScreen } from "../main-screen/main-screen";
import { InfoUnit } from "../info-unit/info-unit";
import { InfoUnitMobiles } from "../info-unit/info-unit-mobiles";
import "../../constructor/common.css";
import { FeatureBlock } from "../feature-block/feature-block";
import { AboutBlock } from "../about-block/about-block";
import { Footer } from "../../footer/footer";
import { FeatureCard } from "../feature-block/feature-card";
// import { Reviews } from "../../reviews/reviews";
import { useState } from "react";

import ContactUsModal from "../../modal/contact-us";
import { useNavigate } from "react-router-dom";

export const CaseBoostpad = () => {
	const navigate = useNavigate();

	document.title = "UX/UI дизайн для криптолаунчпада";
	document.getElementsByTagName("META")[2].content =
		"UX/UI дизайн для цифровых продуктов на технологиях блокчейн: web3, крипто и NFT. Простые и интуитивные интерфейсы для сложных технологий. Разработка под ваши задачи с учетом трендов и потребностей";

	document.getElementsByTagName("META")[3].content =
		"дизайн блокчейн-продуктов, UX/UI дизайн web3, дизайн криптопроектов, дизайн интерфейсов NFT, UX дизайн блокчейн, цифровые продукты web3, дизайн для криптовалют, web3 дизайн интерфейсов, UX/UI для NFT, блокчейн-продукты дизайн";

	return (
		<div className="boostpad">
			<MainScreen
				backgroundColor="radial-gradient(127.41% 100.78% at 50% 65.06%, rgba(179, 130, 255, 0.20) 24.5%, rgba(113, 46, 217, 0.20) 38.5%, rgba(26, 8, 53, 0.20) 53.79%), #0A0A0A"
				titleColor="#FFF"
				textColor="#FFF"
				isHeaderOnLight
			/>

			<AboutBlock />

			<FeatureBlock
				backgroundColor="#1F1F1F"
				title="Целевая аудитория BoostPad: UX-решения для частных инвесторов и стартапов"
				textColor="#FFF"
			>
				<InfoUnit
					title="Создан для двух основных сегментов на рынке криптовалют"
					text={[
						"Стартапам BoostPad предоставляет инфраструктуру для привлечения средств, управление токенами, маркетинговую поддержку и аудит.",
						"Инвесторам он дает доступ к проектам, проверенным аналитиками на безопасность и перспективность, и возможность приобрести токены на выгодных условиях до их листинга на крупных биржах.",
					]}
					textColor="#FFF"
					picture="/img/boostpad/boostpad-screen1-wjet-design.png"
					pictureAlt="Таймлайн с этапами покупки токенов и статусами пользователей"
				/>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#8359D9"
				textColor="#FFF"
				borderRadius={48}
			>
				<InfoUnit
					title="Визуальный стиль. UX/UI дизайн "
					text={[
						"Основное требование к стилистике лаунчпада — сделать его криптовым, технологичным, современным, ярким. Изначально мы планировали акцентировать внимание на 3D-объектах, но затем отказались от этой идеи, чтобы сосредоточить пользователей на функционале интерфейса. Для визуала использовали минималистичные 2d иллюстрации и градиенты.",
					]}
					textColor="#FFF"
					picture="/img/boostpad/boostpad-screen1-wjet-ux-ui-2.png"
					pictureAlt="Этапы продажи токенов с условиями для разных уровней пользователей"
				/>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#303030"
				title="Функциональные возможности лаунчпада"
				textColor="#FFF"
			>
				<div className="infowrapper" style={{ color: "#FFF" }}>
					<div className="textblock">
						<h3 className="infotitle">Таймлайн</h3>
						{[
							"К функционалу предъявлялись свои требования. В первую очередь, необходимо было сделать процесс покупки и получения токенов простым и понятным для пользователя. И отразить все шаги, которые проходит пользователь, на таймлайне. ",
							"Там же, на таймлайне, видно, на каком шаге сейчас находится пользователь, и что (а главное — когда) будет следующим шагом. В будущем таймлайн позволит менять и настраивать уникальные шаги для проектов. Например, можно будет разбить каждый этап на несколько раундов.",
						].map((unit) => (
							<div>{unit}</div>
						))}
					</div>

					<img
						src="/img/boostpad/boostpad-wjet-timeline-3.png"
						className="infopicture"
						alt="Главный экран лаунчпада с ключевыми функциями и навигацией"
					/>
				</div>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#141414"
				title="Этапы пользовательского пути в BoostPad"
				textColor="#FFF"
			>
				<InfoUnit
					textColor="#FFF"
					title="1. Скоро в продаже (upcoming)"
					text={[
						"Этап, когда проект анонсирован, но покупка токенов еще не началась. Дополнительным шагом на этом этапе выступает выполнение требований регуляторов — прохождение KYC, процесса верификации пользователей по их документам.",
					]}
				/>

				<InfoUnit
					textColor="#FFF"
					title="3. Продажа завершена (filled)"
					text={[
						"Этап, когда все токены распроданы, и покупка больше невозможна.",
					]}
					picture="/img/boostpad/boostpad-wjet-step3-4.png"
					pictureAlt="2D-иллюстрации и градиенты в дизайне интерфейса криптолаунчпада"
				/>

				<InfoUnit
					textColor="#FFF"
					title="4. Токены доступны (claimable)"
					text={[
						"Этап, на котором можно начать получать свои токены и переводить их на личный кошелек. При этом обычно не все токены доступны сразу, а выдаются проектом по частям, чтобы защитить рыночную цену токена от резких скачков. Для этого предусмотрен специальный календарь.",
					]}
				/>

				<InfoUnit
					textColor="#FFF"
					title="5. Проект закрыт (ended)"
					text={[
						"Финальная стадия, указывающая на завершение всех обязательств по проекту.",
					]}
					picture="/img/boostpad/boostpad-wjet-step5-4.png"
				/>
			</FeatureBlock>

			<FeatureBlock backgroundColor="#303030" textColor="#FFF">
				<InfoUnit
					title="Основные сложности проекта"
					text={[
						"Главная сложность заключалась в работе над информационной структурой и смыслом.  \n Разработка смысловой структуры в таком проекте требует баланса: важно донести сложные концепции и функционал, не перегружая интерфейс и сохраняя внимание пользователя на ключевых шагах.  \n Интересной задачей было реализовать этап пользовательского пути — Swap. Во-первых, этот шаг проводится в разное время для участников с разными уровнями: чем выше уровень, тем раньше и больше токенов можно купить.",
						"  Эту информацию необходимо было четко и понятно донести пользователям.   \n Во-вторых, сложность вызвала форма покупки. Нужно было спроектировать ее так, чтобы при наличии большого количества информации она оставалась визуально простой и всегда была перед глазами у пользователей. Для этого мы отделили зону действий от зоны расчетов.",
					]}
					textColor="#FFF"
					picture="/img/boostpad/boostpad-wjet-solutions-5.png"
				/>
			</FeatureBlock>

			<FeatureBlock
				backgroundColor="#8359D9"
				textColor="#FFF"
				borderRadius={48}
			>
				<InfoUnit
					title="Интересные детали и фишки проекта BoostPad"
					text={[
						"На каждом этапе мы добавили таймер, который показывает, сколько времени осталось до завершения текущего шага. Мы постарались сделать его супер заметным, чтобы пользователь не терялся. Это же касается и таймлайна, про который рассказывали выше",
					]}
					textColor="#FFF"
					picture="/img/boostpad/boostpad-wjet-details-6.png"
				/>
			</FeatureBlock>

			<FeatureBlock
				title="Дизайн-система BoostPad"
				backgroundColor="#0A0A0A"
				textColor="#FFF"
			>
				<InfoUnit
					title="Минимум компонентов, максимум гибкости"
					text={[
						"Мы создали компактную дизайн-систему, которая удобна для разработчиков. Она проста и быстра в управлении и поддержке, что важно для дальнейшего развития и масштабирования продукта. Мы свели количество компонентов к минимуму, но сделали их гибкими при сборке следующих экранов.",
						"В основе всей дизайн-системы — переменные (variables) и компоненты, что очень удобно. Например, с помощью переменных достаточно сделать небольшое изменение размера шага сетки + кегль — и это повлияет сразу на все макеты. Так мы можем выбрать нужный масштаб всего интерфейса, на финальном этапе проработки дизайна. Так же это помогает быстрее делать адаптивные макеты. ",
					]}
					textColor="#FFF"
					picture="/img/boostpad/boostpad-wjet-design-system-7.png"
				/>

				<button
					className="action__button"
					onClick={() => {
						navigate(`?modal`);
					}}
				>
					Обсудить мой проект
				</button>
			</FeatureBlock>

			{/* <FeatureBlock 
			backgroundColor="#303030" 
									textColor="#FFF"

			title="Отзыв заказчика">
				<InfoUnit
										textColor="#FFF"

					text={[
						" Получилось именно то, что мы хотели — лаунчпад понятный, без лишнего, всё как надо. Отдельный респект за скорость — для нас сроки были критически важны, особенно сейчас, когда рынок горячий. Благодаря вашей оперативности мы уже получили инвестиции и активно привлекаем	проекты. Еще раз спасибо за профессионализм — работать с вами одно удовольствие! Савельев Алексей (CEO BoostPad)",
						]}
					// picture="/img/boostpad/wjet-review.png"

				/>
			</FeatureBlock> */}

			{/* <Reviews /> */}

			<section className="design" id="design">
				<div className="container" id="contacts">
					<Footer backgroundColor="transparent" />
				</div>
			</section>

			<ContactUsModal />
		</div>
	);
};
